import { Helper } from './Helper';
import { PhoneNumberHelper } from './PhoneNumberHelper';
import { AppConfig } from '../../AppConfig';

export class ValidationHelper {
  static validateFields(formField, value) {
    if (formField &&
        formField.required &&
        formField.required.value &&
      (!value || value.length === 0)) {
      return '*' + formField.required.err || null
    } else if (formField &&
        formField.email &&
        formField.email.value &&
        value &&
        !Helper.validateAndFormatEmailV2(value)) {
      return formField.email.err || null
    } if (formField &&
        formField.phone &&
        formField.phone.value &&
        value &&
        !PhoneNumberHelper.formatNumberV2(value, AppConfig.DefaultCountry)) {
      return formField.phone.err || null
    } else {
      return null
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/helpers/ValidationHelper.js